import PropTypes from 'prop-types';
import React from 'react';

import { useEntity } from '../../entities/hooks';
import Avatar from '../../app/avatar';

const MemberAvatar = ({ id, memberId, ...props }) => {
  const { member } = useEntity({ id: memberId || id, type: 'members' });
  const { entity: imageEntity } = useEntity(member['avatar-image'])

  let imageId = null;
  if (imageEntity['canvas-image'] && imageEntity['canvas-image']?.id) {
    imageId = imageEntity['canvas-image'].id
  } else if (member['avatar-image'] && member['avatar-image'].id) {
    imageId = member['avatar-image'].id
  }

  return (
    <Avatar
      imageId={imageId}
      name={member['full-name']}
      fallbackUrl={member['avatar-url']}
      {...props}
    />
  );
};

MemberAvatar.propTypes = {
  id: PropTypes.string,
  memberId: PropTypes.string,
};

MemberAvatar.defaultProps = {
  memberId: '',
  id: '',
};

export default MemberAvatar;
